import { render } from "./ComponentAiQuotaHint.vue?vue&type=template&id=10684e75&scoped=true"
import script from "./ComponentAiQuotaHint.vue?vue&type=script&lang=js"
export * from "./ComponentAiQuotaHint.vue?vue&type=script&lang=js"

import "./ComponentAiQuotaHint.vue?vue&type=style&index=0&id=10684e75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10684e75"]])

export default __exports__